<template>
  <footer class="site-footer">
    <HarlequinBorder />
    <div class="site-footer__top">
      <div class="footer-brand">
        <router-link to="/" class="footer-logo">Walls <span>&amp;</span> Faces</router-link>
        <p>Hand-curated vintage art &amp; interiors.<br>Real art at honest prices.</p>
        <div class="footer-social">
          <a href="#" aria-label="Instagram">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".5" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Pinterest">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/><path d="M11 8.5c2.5-1 5 .5 4.5 3s-2.5 3.5-4 2.5M11.5 10 9 21"/>
            </svg>
          </a>
        </div>
      </div>

      <nav class="footer-nav" aria-label="Footer">
        <div v-for="menu in menus" :key="menu.label" class="footer-nav__col">
          <h4>{{ menu.label }}</h4>
          <template v-for="link in menu.links" :key="link.label">
            <router-link v-if="link.to.startsWith('/')" :to="link.to">{{ link.label }}</router-link>
            <a v-else :href="link.to">{{ link.label }}</a>
          </template>
        </div>
        <div class="footer-nav__col">
          <h4>Help</h4>
          <a v-for="link in helpLinks" :key="link" href="#">{{ link }}</a>
        </div>
      </nav>
    </div>

    <div class="site-footer__bottom">
      <p>© {{ year }} Walls &amp; Faces</p>
      <p class="footer-payment">Visa &nbsp;·&nbsp; Mastercard &nbsp;·&nbsp; PayPal &nbsp;·&nbsp; Apple Pay</p>
    </div>
  </footer>
</template>

<script>
import { MAIN_MENU } from '../../navigation'
import HarlequinBorder from '../HarlequinBorder.vue'

export default {
  name: 'SiteFooter',

  components: { HarlequinBorder },

  data() {
    return {
      menus: MAIN_MENU,
      helpLinks: ['Shipping & Delivery', 'Returns', 'Care Guide', 'FAQ', 'Privacy Policy'],
      year: new Date().getFullYear(),
    }
  },
}
</script>

<style scoped>
.site-footer {
  background: var(--canvas);
  color: var(--ink);
}

.site-footer__top {
  max-width: var(--max-w);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 28rem 1fr;
  gap: 6.4rem;
  padding: 7.2rem 4rem 4.8rem;
  border-bottom: 1px solid var(--linen);
}

.footer-logo {
  display: block;
  font-family: var(--font-display);
  font-size: 3rem;
  font-weight: 500;
  color: var(--ink);
  margin-bottom: 1.4rem;
}

.footer-logo span { font-style: italic; color: var(--amber); }

.footer-brand p {
  font-size: 1.4rem;
  line-height: 1.7;
  color: var(--stone);
  margin-bottom: 2.4rem;
}

.footer-social {
  display: flex;
  gap: 1.6rem;
}

.footer-social a {
  color: var(--stone);
  transition: color 0.15s;
}
.footer-social a:hover { color: var(--amber); }

.footer-nav {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3.2rem;
}

.footer-nav__col {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-nav__col h4 {
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--amber);
  margin-bottom: 0.6rem;
}

.footer-nav__col a {
  font-size: 1.4rem;
  color: var(--charcoal);
  transition: color 0.15s;
}
.footer-nav__col a:hover { color: var(--amber); }

.site-footer__bottom {
  max-width: var(--max-w);
  margin: 0 auto;
  padding: 2.8rem 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.site-footer__bottom p {
  font-size: 1.2rem;
  color: var(--stone);
}

.footer-payment { letter-spacing: 0.04em; }

@media (max-width: 960px) {
  .site-footer__top { grid-template-columns: 1fr; gap: 4rem; padding: 5.6rem 1.6rem 4rem; }
  .footer-nav { grid-template-columns: 1fr 1fr; }
  .site-footer__bottom { flex-direction: column; gap: 0.8rem; text-align: center; padding: 2.4rem 1.6rem; }
}
</style>
